import { render } from "./addquotation.vue?vue&type=template&id=a17e8936"
import script from "./addquotation.vue?vue&type=script&lang=js"
export * from "./addquotation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-MakProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__